import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  id: string;
};

async function deleteDocumentType(variables: Variables) {
  const { error } = await apiClient
    .from('document_types')
    .delete()
    .eq('id', variables.id);

  if (error) {
    if (error.code === '23503') {
      throw new Error('Impossible de supprimer ce type car des documents y sont encore associés.');
    }
    if (error.message?.includes('Cannot delete system document type')) {
      throw new Error('Les types de documents par défaut du système ne peuvent pas être supprimés.');
    }
    throw error;
  }
}

export function useDeleteDocumentType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) => deleteDocumentType(variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.documents });
      enqueueSnackbar('Type de document supprimé. Les documents associés ont été réassignés à "Autre".', 'success');
    },
    onError: (error: Error) => {
      enqueueSnackbar(error.message || 'Erreur lors de la suppression du type de document.', 'error');
    },
  });
}
